import { createWeatherMapPollingQueryOptions } from '../../../utils/weatherMapQuery.utils';

export const CURRENT_CONDITIONS_ROUTE = 'getAirportConditionsbyState';

export const CURRENT_CONDITIONS_REFRESH_INTERVAL_MINUTES = 60;

export const CURRENT_CONDITIONS_QUERY_OPTIONS = createWeatherMapPollingQueryOptions({
  refreshIntervalMinutes: CURRENT_CONDITIONS_REFRESH_INTERVAL_MINUTES,
  refetchIfOlderThanMinutes: CURRENT_CONDITIONS_REFRESH_INTERVAL_MINUTES,
});

export const CURRENT_CONDITIONS_DEFAULT_ZOOM = 9;

export const CURRENT_CONDITIONS_CLUSTER_RADIUS = 160;

export const CURRENT_CONDITIONS_REFRESH_ERROR_TOAST_ID = 'current-conditions-refresh-error';
